import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg24NotioffG = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey400,
        fillRule: "nonzero",
        d: "m18.28 9.658.005.234-.001 3.299 1.37 1.158c.238.2.4.472.467.769l.025.15.009.154v.79c0 .736-.567 1.337-1.287 1.405l-.136.006-3.383.001c-.227 1.916-1.586 3.28-3.349 3.28s-3.122-1.364-3.349-3.28H5.268q-.183 0-.354-.045l1.264-1.266 12.554.001a.11.11 0 0 0 .105-.063l.008-.038v-.79a.1.1 0 0 0-.016-.052l-.02-.022-1.833-1.55V9.892c0-1.243-.41-2.383-1.096-3.28l.932-.932a6.68 6.68 0 0 1 1.469 3.978m-4.269 8.049H9.988l.011.063c.211.998.864 1.67 1.698 1.802l.158.018.145.005c.922 0 1.677-.632 1.956-1.643l.045-.182zM12 3.345c1.45 0 2.782.51 3.843 1.366l-.934.931A4.8 4.8 0 0 0 12 4.655c-2.675 0-4.861 2.222-4.971 5.015l-.005.222v3.636l-1.745 1.744-.089.077a.1.1 0 0 0-.03.042L3.912 16.64q-.045-.14-.06-.291l-.007-.136v-.79c0-.362.14-.708.388-.968l.112-.106 1.37-1.158v-3.3c0-3.448 2.564-6.289 5.835-6.53l.224-.011z"
      }), /*#__PURE__*/jsx("path", {
        stroke: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey400,
        strokeLinecap: "round",
        strokeWidth: 1.371,
        d: "m3.4 20 16-16"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24NotioffG$1 = Svg24NotioffG;

export { Svg24NotioffG$1 as default };
